<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kbOBXZ/tc-custom/9781137000187.jpg?1729937558390" alt="This image is the cover for the book Slave in the White House"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Slave in the White House
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>New York Times</i></b><b> Bestseller: A “fascinating portrait” of one of the men enslaved by James and Dolley Madison, and his journey toward freedom (<i>Publishers Weekly</i>).</b><br/>  <br/> Paul Jennings was born into slavery on the plantation of James and Dolley Madison in Virginia, later becoming part of the Madison household staff at the White House. Once he was finally emancipated by Senator Daniel Webster later in life, he would give an aged and impoverished Dolley Madison, his former owner, money from his own pocket, write the first White House memoir, and see his sons fight with the Union Army in the Civil War. He died a free man in northwest Washington at seventy-five.<br/>  <br/> Based on correspondence, legal documents, and journal entries rarely seen before, this amazing portrait of the times reveals the mores and attitudes toward slavery of the nineteenth century, and sheds new light on famous figures such as James Madison, who believed the white and black populations could not coexist as equals; General Lafayette, who was appalled by this idea; Dolley Madison, who ruthlessly sold Paul after her husband’s death; and many other since-forgotten slaves, abolitionists, and civil right activists.<br/>  <br/> “A portrait of a remarkably willful, ambitious, opportunistic, and in his own way well-connected American. You could also call it the American dream.” —<i>Fortune</i><br/>  <br/> “A great historical biography.” —<i>Houston Style Magazine</i><br/>  <br/> “A must-read.” —<i>The Daily Beast</i><br/>  <br/> “Thorough research . . . an important story of human struggle, determination, and triumph.” —<i>The Dallas Morning News</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Elizabeth Dowling Taylor, Annette Gordon-Reed
      </h2>
      
      <p class="authorDescription body article"><P><B>Elizabeth Dowling Taylor</B> received her Ph.D. from the University of California at Berkeley. Over a 22-year career in museum education and historical research, she was Director of Interpretation at Thomas Jefferson's Monticello and Director of Education at James Madison's Montpelier. Most recently a Fellow at the Virginia Foundation for the Humanities, Taylor is now an independent scholar and lecturer. She lives in Barboursville, Virginia.<br><br><B>Annette Gordon-Reed,</B> historian and legal scholar, has a triple appointment at Harvard University, where she is Professor at the Law School, History Department, and Radcliffe Institute for Advanced Study.  In 2009 she won the Pulitzer Prize in history for her book, <I>The Hemingses of Monticello: An American Family.</I></P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?43e80dcd